import type { Doc } from "building-types/doc";
import type { DocEntityHandle, LevelHandle } from "building-types/handles/docEntityHandleTypes";
import docEntityGetParent from "./entity/docEntityGetParent";

export function docEntityGetLevel(doc: Doc, handle: DocEntityHandle): LevelHandle | null {
  if (!handle) {
    return null;
  }

  if (handle.type === "LEVEL") {
    return handle;
  }

  const parent = docEntityGetParent(doc, handle);

  return parent ? docEntityGetLevel(doc, parent) : null;
}
